{
  "appName": "Osvitly",
  "tagline": "Шкільна платформа для тих, хто вчить і вчиться",
  "loading": "Завантаження…",
  "save": "Зберегти",
  "cancel": "Скасувати",
  "continue": "Продовжити",
  "back": "Назад",
  "close": "Закрити",
  "language": "Мова",
  "languages": {
    "en": "English",
    "uk": "Українська"
  },
  "theme": {
    "label": "Тема",
    "light": "Світла",
    "dark": "Темна",
    "system": "Системна"
  },
  "roles": {
    "admin": "Адміністратор",
    "teacher": "Вчитель",
    "pupil": "Учень",
    "parent": "Батьки"
  },
  "notFound": {
    "title": "Сторінку не знайдено",
    "description": "Такої сторінки не існує, або її було переміщено.",
    "backHome": "На головну"
  },
  "permissionDenied": {
    "title": "Немає доступу",
    "description": "У вас немає прав для перегляду цієї сторінки."
  },
  "actions": "Дії",
  "pagination": {
    "showing": "{{from}}–{{to}} з {{count}}",
    "previous": "Попередня сторінка",
    "next": "Наступна сторінка"
  },
  "footer": "© {{year}} Osvitly. Усі права захищено.",
  "openMenu": "Відкрити меню навігації",
  "navigation": "Навігація",
  "showSidebar": "Показати бокову панель",
  "hideSidebar": "Сховати бокову панель",
  "password": {
    "show": "Показати пароль",
    "hide": "Приховати пароль"
  }
}
